import moment from 'moment';
import CommentEntity from '../Entity/Comment';
import 'moment/locale/ru';

export default function CommentFactory(data) {
    const comment = {};
    let element;

    element = data.id;
    if (typeof element !== 'undefined') {
        comment.id = element;
    }

    element = data.user;
    if (typeof element !== 'undefined') {
        comment.user = element;
    }

    element = data.created;
    if (typeof element !== 'undefined') {
        comment.created = moment(element, 'YYYY-MM-DD hh:mm:ss');
    }

    element = data.text;
    if (typeof element !== 'undefined') {
        comment.text = element;
    }

    element = data.rate;
    if (element !== 'undefined') {
        comment.rate = parseFloat(element);
    }

    element = data.mealRate;
    if (element !== 'undefined') {
        comment.mealRate = parseFloat(element);
    }

    element = data.serviceRate;
    if (element !== 'undefined') {
        comment.serviceRate = parseFloat(element);
    }

    element = data.locationRate;
    if (element !== 'undefined') {
        comment.locationRate = parseFloat(element);
    }

    return new CommentEntity(comment);
}